import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';
import {TimeSheetsStore} from 'projects/desktop/src/app/modules/timesheets/data/time-sheets.store';
import {environment} from 'projects/desktop/src/environments/environment';
import {HttpService, cacheResult} from 'projects/core/src/public-api';
import {User} from 'projects/core/src/lib/login/data/user';
import {Memoize} from 'projects/core/src/lib/core/utils/decorators/memoize-decorator';
import {UserResponcePage} from './user-responce-page';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {SearchBody} from '../../search/data/searchBody';


@Injectable({
  providedIn: 'root'
})
export class UsersService extends HttpService {

  constructor(
    protected injector: Injector,
    protected timeSheetsStore: TimeSheetsStore
  ) {
    super(injector);
  }

  getUser(userId: number): Observable<User> {
    return this.getData(`/user/${userId}`, User)
  }

  // @Memoize()
  getRoles(): Observable<UserRole[]> {
    return this.doHttpGet<UserRole[]>(`/user/role/list`)
      .pipe(
        cacheResult(environment.dataDefaultCacheTime)
      );
  }

  createUser(user: User): Observable<User> {
    return this.postData(`/user/create`, user, User, true);
  }

  updateUser(user: User): Observable<User> {
    return this.putData(`/user/update`, user, User, true);
  }

  toggleUser(userId: number, status: boolean): Observable<User> {
    return this.postData(`/user/${userId}/enabled/${status}`, {}, User);
  }

  getAllUsers(page: number, limit: number): Observable<UserResponcePage> {
    return this.getData(`/user/list/by-page?start=${page}&limit=${limit}`, UserResponcePage);
  }

  getActiveUsers(): Observable<User[]> {
    return this
      .getData(`/user/list/enabled`, User)
      .pipe(
        cacheResult(environment.dataDefaultCacheTime)
      );
  }

  searchUsers(reqString: string, includeInactive = false): Observable<User[]> {
    return this.postData(`/user/list/search`, {
      query: reqString,
      includeInactive
    } as SearchBody, User);
  }


  getUsersByRoles(page: number, limit: number, roles: string, showActive: boolean): Observable<UserResponcePage> {
    if (isNaN(page)) {
      page = 0;
    }
    if (isNaN(limit)) {
      limit = 10;
    }
    if (showActive) {
      return this.getData(`/user/list/for-roles?roles=${roles}&start=${page}&limit=${limit}&enabled=${showActive}`, UserResponcePage);
    } else {
      return this.getData(`/user/list/for-roles?roles=${roles}&start=${page}&limit=${limit}`, UserResponcePage);
    }
  }

  getUsersByActivityType(type: string): Observable<User[]> {
    return this.getData(`/user/list/for-activity-type?name=${type}`, User);
  }

  getUsersByActivityTypes(types: string): Observable<User[]> {
    return this.getData(`/user/list/for-activity-type?names=${types}`, User);
  }

  resetPassword(userId: number): Observable<User> {
    return this.putData(`/user/${userId}/reset-passwords`, {}, User);
  }

  resetPin(userId: number): Observable<User> {
    return this.putData(`/user/${userId}/reset-pin`, {}, User);
  }

  updateUserPositions(userPositions: Array<{userId: number, position: number}>): Observable<User[]> {
    return this.putData(`/user/installation-positions`, userPositions, User);
  }

}
